(function() { window.GUID_fddc19fa_138e_4ee2_ad6c_046366dd7061 = { getGuid: function() { return "fddc19fa-138e-4ee2-ad6c-046366dd7061"; } }; })();
function useYoutubePlayer() {
    const cookieConsent = CS.CookieConsent;
    return cookieConsent && typeof cookieConsent.CanUseYoutubeEmbeds === "function"
        ? cookieConsent.CanUseYoutubeEmbeds()
        : false;
}
function useFacebookPlayer() {
    const cookieConsent = CS.CookieConsent;
    return cookieConsent && typeof cookieConsent.CanUseMetaPixel === "function"
        ? cookieConsent.CanUseMetaPixel()
        : false;
}
function ensureYouTubeIframeApiLoaded() {
    if (!useYoutubePlayer()) {
        return;
    }
    const len = $('script').filter(function () {
        return ($(this).attr('src') == 'https://www.youtube.com/iframe_api');
    }).length;
    if (len === 0) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-videostreams',
                        callback: (accordion, e) => {
                            const $bodyElements = accordion.$Content.find(".video-stream-box__body");
                            $('.accordion-videostreams').offon('click.video-stream-box', '.video-stream-box', (e) => {
                                const $target = $(e.target);
                                const $container = $target.closest(".video-stream-box");
                                if ($target.closest('.button-remove-stream').length > 0) {
                                    CS.Controls.Popup.ShowAreYouSure(() => {
                                        CS.Ajax.Post($target.closest('.button-remove-stream').data('url'), null, (response) => {
                                            if (response.success) {
                                                $container.slideUp();
                                            }
                                            else {
                                                //Should never happen
                                                alert('You are not allowed to remove this video!');
                                            }
                                        });
                                    });
                                    return;
                                }
                                else if ($target.closest('.button--stream').length > 0) {
                                    return;
                                }
                                const $blockedPlayer = $container.find('.iframe-yt, .iframe-fb').filter((index, element) => $(element).hasClass('iframe-yt') ? !useYoutubePlayer() : !useFacebookPlayer());
                                if ($blockedPlayer.length > 0) {
                                    e.preventDefault();
                                    $container.addClass('expanded').removeClass('playable');
                                    $container.find('.video-stream-box__play-btn-container').hide();
                                    $blockedPlayer.css('padding-top', '0');
                                    $blockedPlayer.find('.video-stream-box__thumbnail, .thumbnail, .player, .fb-video, .fb-plugin, .iframe-overlay').hide();
                                    $blockedPlayer.find('.youtube-consent-placeholder, .facebook-consent-placeholder').css('display', 'flex');
                                    return;
                                }
                                if ($container.length > 0 && !$container.hasClass("expanded")) {
                                    $container.addClass("expanded");
                                    let yt = $container.find('.iframe-yt');
                                    if (yt.length > 0) {
                                        if (useYoutubePlayer()) {
                                            //yt.css('padding-top', 'calc(56.25%)');
                                            //yt.find('.video-stream-box__thumbnail').hide();
                                            //yt.find('.player').removeClass('hidden');
                                            ensureYouTubeIframeApiLoaded();
                                            processYouTubePlayers();
                                        }
                                    }
                                    //if (!$container.hasClass('playable')) {
                                    //    $container.find('.iframe-overlay').show();
                                    //    $container.find('.thumbnail').show();
                                    //} else {
                                    //    $container.find('.iframe-overlay').hide();
                                    //    $container.find('.thumbnail').hide();
                                    //}
                                    if (CS.CommonData.Current.IsNativeApp) {
                                        CS.NativeApp.NA_DisableRefresh();
                                    }
                                    //Pour régler que le video se resize pas
                                    let $fbvideo = $container.find('.fb-video, .fb-plugin');
                                    if ($fbvideo.length > 0) {
                                        $fbvideo.html('');
                                        $fbvideo.removeClass('fb_iframe_widget');
                                        $fbvideo.removeClass('fb_iframe_widget_fluid');
                                        $fbvideo.removeAttr('fb-xml-state');
                                        $fbvideo.removeAttr('fb-iframe-plugin-query');
                                        if (useFacebookPlayer()) {
                                            handleFacebookVideos($container, 0);
                                        }
                                    }
                                    //$bodyElement.css({ cursor: "default" });s
                                    //$bodyElement.off(jqueryEventId);
                                }
                            });
                            console.log('stream accordion ready');
                            if (useYoutubePlayer()) {
                                $('body').offon('YoutubeVideoLoaded.videos', (e, id) => {
                                    CS.Debug.Log('video can be played in app ' + id + ' ' + e);
                                    let yt = accordion.$Content.find(`.iframe-yt[data-videoid=${id}]`);
                                    CS.Debug.Log(yt.length);
                                    yt.closest('.video-stream-box').addClass('playable');
                                    //yt.css('padding-top', 'calc(56.25%)');
                                    //yt.find('.video-stream-box__thumbnail').hide();
                                    //yt.find('.player').removeClass('hidden');
                                    //yt.find('.thumbnail').hide();
                                });
                                $('body').offon('YoutubeVideoCantPlay.videos', (e, id) => {
                                    CS.Debug.Log('video can NOT be played in app ' + id + ' ' + e);
                                    //let yt = accordion.$Content.find(`.iframe-yt[data-videoid=${id}]`);
                                    //yt.find('.player').addClass('hidden');
                                    //yt.find('.video-stream-box__thumbnail').hide();
                                    //yt.find('.thumbnail').show();
                                });
                                ensureYouTubeIframeApiLoaded();
                                processYouTubePlayers();
                            }
                            let $fbvideo = accordion.$Content.find('.fb-video, .fb-plugin');
                            if ($fbvideo.length > 0 && useFacebookPlayer()) {
                                CS.Debug.Log('FacebookVideoLoaded.videos ');
                                $('body').offon('FacebookVideoLoaded.videos', (e, id) => {
                                    CS.Debug.Log('video can be played in app ' + id + ' ' + e);
                                    $('#video-' + id).closest('.video-stream-box').addClass('playable');
                                    //$('#video-' + id).show();
                                    //$('#video-' + id).parent().find('.thumbnail').hide();
                                });
                                if (typeof (FB) !== 'undefined') {
                                    handleFacebookVideos($('.accordion-videostreams'), 1000);
                                }
                                else {
                                    CS.DOM.$body.on('facebookinitialized.videostreams', () => {
                                        handleFacebookVideos($('.accordion-videostreams'), 1000);
                                    });
                                }
                            }
                            //Check all youtube thumbnails to see if it's the notavailable.jpg
                            let $img = accordion.$Content.find('.iframe-yt .video-stream-box__thumbnail');
                            $img.each((i, e) => {
                                if (e.complete) {
                                    console.log(e.naturalWidth + 'x' + e.naturalHeight);
                                    if (e.naturalWidth < 200) {
                                        //Replace thumbnail
                                    }
                                }
                                else {
                                    e.addEventListener('load', () => {
                                        console.log('loaded ' + e.naturalWidth + 'x' + e.naturalHeight);
                                    });
                                    e.addEventListener('error', function () {
                                        console.error('stream thumbnail not loaded');
                                    });
                                }
                            });
                        }
                    });
                    CS.Controls.Accordion.Events.ContentLoaded({
                        selector: 'body',
                        childSelector: '.accordion-videostreams',
                        callback: (accordion, e) => {
                            console.log('ContentLoaded');
                            if (useYoutubePlayer()) {
                                ensureYouTubeIframeApiLoaded();
                                processYouTubePlayers();
                            }
                            //TODO: faire une loop juste sur les videos non traités (qui viennent d'etre ajoutés)
                            if (useFacebookPlayer()) {
                                handleFacebookVideos($('.accordion-videostreams'), 1000);
                            }
                        }
                    });
                    function handleFacebookVideos(element, timeout = 0) {
                        if (!useFacebookPlayer() || !element || element.length == 0) {
                            return;
                        }
                        setTimeout(() => {
                            console.log('handleFacebookVideos');
                            if (typeof (FB) !== 'undefined') {
                                FB.Event.unsubscribe('xfbml.ready', fbReady);
                                FB.Event.subscribe('xfbml.ready', fbReady);
                                FB.XFBML.parse(element[0]);
                                CS.DOM.$body.off('facebookinitialized.videostreams');
                            }
                        }, timeout);
                    }
                    WallSections.handleFacebookVideos = handleFacebookVideos;
                    function fbReady(msg) {
                        //fbReady est seulement appelé si le video se load pour vrai.
                        console.log('fbReady ' + msg.type + ' ' + msg.id);
                        if (msg.type === 'video') {
                            $('body').trigger('FacebookVideoLoaded', [msg.id.replace('video-', '')]);
                            let starttime = $('#' + msg.id).closest('.iframe-fb').data('starttime');
                            if (starttime && msg.instance) {
                                console.log('video seeking ' + starttime);
                                msg.instance.seek(starttime);
                            }
                            console.log(msg.instance.getDuration());
                            msg.instance.subscribe('startedPlaying', function (e) {
                                console.log('video started ' + msg.id);
                                console.log(msg.instance.getDuration());
                                console.log(msg.instance.getCurrentPosition());
                                //TODO: save duration in db
                                if (msg.instance.getCurrentPosition() == 0) {
                                    CS.Analytics.Event("video", "started", msg.id);
                                }
                            });
                            msg.instance.subscribe('error', function (e) {
                                console.log('video error ' + msg.id);
                            });
                        }
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));
ensureYouTubeIframeApiLoaded();
var players = new Object();
function processYouTubePlayers() {
    if (!useYoutubePlayer()) {
        return;
    }
    $.each($(".video-stream-box.expanded .iframe-yt, .iframe-yt.add-video"), (index, v) => {
        let id = $(v).data("id");
        let videoId = $(v).data("videoid");
        let start = $(v).data("starttime");
        console.log("iframe-yt " + id + " " + videoId);
        if ($(v).find('div.player').length > 0) {
            console.log("div.player ");
            //if (!players[videoId]) {
            console.log("iframe-container " + id + " " + videoId);
            try {
                let player = new YT.Player('player-' + id, {
                    height: '360',
                    width: '640',
                    videoId: videoId,
                    playerVars: {
                        modestbranding: 1,
                        showinfo: 0,
                        //autoplay: 1,
                        start: start,
                        origin: 'compusport.us',
                        fs: 1
                    },
                    //origin: "http://localhost",
                    events: {
                        'onReady': onPlayerReady,
                        'onError': onPlayerError,
                        'onStateChange': onPlayerStateChange
                    }
                });
                players[videoId] = player;
                //}
            }
            catch (e) {
                console.error(JSON.stringify(e));
            }
        }
    });
}
function onYouTubeIframeAPIReady() {
    if (useYoutubePlayer()) {
        CS.Helper.log('Video-Stream', "onYouTubeIframeAPIReady");
        try {
            CS.DOM.$body.trigger("YouTubeReady.global");
            processYouTubePlayers();
        }
        catch (_a) {
            console.error("onYouTubeIframeAPIReady exception");
        }
    }
}
// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
    var _a, _b, _c;
    console.log("onPlayerReady" + JSON.stringify(event));
    let videoId = ((_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.playerInfo) === null || _b === void 0 ? void 0 : _b.videoData) === null || _c === void 0 ? void 0 : _c.video_id) || -1;
    //players[videoId].cueVideoById(videoId);
    if (videoId > -1 && players[videoId]) {
        console.log("onPlayerReady state=" + players[videoId].getPlayerState());
        if (players[videoId].getPlayerState() == 5) {
            $('body').trigger('YoutubeVideoLoaded', [videoId]);
        }
        else if (players[videoId].getPlayerState() == -1) {
            $('body').trigger('YoutubeVideoCantPlay', [videoId]);
        }
    }
}
function onPlayerStateChange(event) {
    console.log("onPlayerStateChange " + event.target.playerState + ' ' + JSON.stringify(event));
    if (event.data == YT.PlayerState.CUED || event.data == YT.PlayerState.UNSTARTED) {
        //player.playVideo();
    }
}
function onPlayerError(event) {
    console.log("onPlayerError" + JSON.stringify(event));
    console.log("onPlayerError :" + event.target.playerInfo.videoData.video_id);
    if (event.data == 101 || event.data == 150) {
        // embed disabled
        console.log("embed disabled");
        //show thumbnail and hide the video
        $(".iframe-container[data-videoId='" + event.target.playerInfo.videoData.video_id + "'] iframe").remove();
        $(".iframe-container[data-videoId='" + event.target.playerInfo.videoData.video_id + "'] .iframe-overlay").remove();
        $(".iframe-container[data-videoId='" + event.target.playerInfo.videoData.video_id + "']").css('padding-top', 0);
        $(".thumbnail[data-videoId='" + event.target.playerInfo.videoData.video_id + "']").removeClass("hidden");
        //window.open(event.target.playerInfo.videoUrl, '_blank').focus();
    }
    if (event.data == 2 || event.data == 100) {
        // embed disabled
        console.log("video can't be found or not public");
        //TODO: ajax to set video inactive
        //But this should not be called since it's also done on server
        window.open(event.target.playerInfo.videoUrl, '_blank').focus();
    }
}

//# sourceMappingURL=video-streams.js.map
